// extracted by mini-css-extract-plugin
export default {"root":"WHDEVHHcdlK3eVw1nfQF"};